import React, { Component, Fragment } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router-dom';

import config from '../../config';

import styles from './SignInPage.css';

class SignInPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };

    state = {
        email: '',
        password: '',
        error: '',
    };

    handleButtonClick = () => {
        const {
            intl: { formatMessage },
        } = this.props;
        const { email, password } = this.state;

        this.setState({ error: '' });

        fetch(`${config.backend}/login`, {
            method: 'POST',
            body: JSON.stringify({ email, password }),
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
        })
            .then(res => {
                if (res.ok) {
                    localStorage.setItem('signedInOnce', true);
                    window.location = '/';
                } else {
                    this.setState({ error: formatMessage({ id: 'SignInPage.No such user' }) });
                }
            })
            .catch(() => this.setState({ error: formatMessage({ id: 'SignInPage.No such user' }) }));
    };

    handleKeyDown = e => {
        if (e.which === 13) {
            this.handleButtonClick();
        }
    };

    handleEmailEnter = (e, value) => {
        if (this.state.error) {
            this.setState({ error: '' });
        }

        this.setState({ email: value });
    };

    handlePasswordEnter = (e, value) => {
        if (this.state.error) {
            this.setState({ error: '' });
        }

        this.setState({ password: value });
    };

    handleRegisterLinkClick() {
        localStorage.removeItem('signedInOnce');
    }

    render() {
        const {
            intl: { formatMessage },
        } = this.props;

        return (
            <Fragment>
                <FormattedMessage id="SignInPage.Sign In to the system" />
                <br />
                <span className={styles.subtitle}>
                    <FormattedMessage id="SignInPage.No account?" />
                    <Link to="/" onClick={this.handleRegisterLinkClick}>
                        <FormattedMessage id="SignUpPage.Sign up" />
                    </Link>
                </span>
                <TextField
                    value={this.state.email}
                    onChange={this.handleEmailEnter}
                    floatingLabelText={formatMessage({ id: 'SignInPage.email' })}
                    fullWidth
                    errorText={this.state.error}
                    errorStyle={{ float: 'left' }}
                    onKeyDown={this.handleKeyDown}
                />
                <TextField
                    value={this.state.password}
                    onChange={this.handlePasswordEnter}
                    floatingLabelText={formatMessage({ id: 'SignInPage.password' })}
                    fullWidth
                    type="password"
                    onKeyDown={this.handleKeyDown}
                />
                <RaisedButton
                    label={formatMessage({ id: 'SignInPage.sign in' })}
                    primary={true}
                    className={styles.button}
                    onClick={this.handleButtonClick}
                />
                <Link
                    to={{ pathname: '/reset-password', state: { email: this.state.email } }}
                    className={styles.forgot}
                >
                    <FormattedMessage id="SignUpPage.Forgot password" />
                </Link>
            </Fragment>
        );
    }
}

export default injectIntl(SignInPage);



// WEBPACK FOOTER //
// ./src/Pages/SignInPage/SignInPage.js